import api from "../../../services/axiosConfig";
import { MODULE_INSTANCE_CONFIG } from "./InstanceConfig";

export const deleteInstance = async (
  title,
  containerIds,
  setLoading,
  setContainerIds,
  setCardStatus,
  toast,
  setExposedPorts,
) => {
  const config = MODULE_INSTANCE_CONFIG[title];
  if (!config) {
    toast?.current?.show({
      severity: "error",
      summary: "Error",
      detail: `Unknown module: ${title}`,
    });
    return;
  }

  setLoading((prev) => ({ ...prev, [title]: true }));
  try {
    const method = config.destroyMethod === "delete" ? api.delete : api.post;
    const response = await method(
      `/instances/${config.url}/${config.destroyEndpoint}`,
      {
        headers: { Accept: "application/json" },
        ...(method === api.delete ? { data: {} } : {}),
      },
    );

    if (response.data.statusCode === 200) {
      setContainerIds((prev) => ({ ...prev, [title]: null }));
      setCardStatus((prev) => ({ ...prev, [title]: "DELETED" }));
      if (setExposedPorts)
        setExposedPorts((prev) => ({ ...prev, [title]: null }));
      toast?.current?.show({
        severity: "success",
        summary: "Success",
        detail: config.destroyMsg,
      });
    } else {
      throw new Error("Failed to Delete Instance");
    }
  } catch (error) {
    if (error.response?.status === 403) {
      toast?.current?.show({
        severity: "error",
        summary: "Permission Denied",
        detail: "You don't have permission to access this resource",
      });
    } else {
      toast?.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to Delete Instance",
      });
    }
    console.error("Error during deleteInstance:", error);
  } finally {
    setLoading((prev) => ({ ...prev, [title]: false }));
  }
};
